module.exports = __webpack_public_path__ + "img/publicidad.ddb29e19.png";